import Vue from 'vue'
import Router from 'vue-router'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

// import {
//   initCurrentUserStateMiddleware,
//   checkAccessMiddleware,
//   setPageTitleMiddleware,
// } from "./middlewares";
import { routes } from './routes'

Vue.use(Router)

const router = new Router({
  // linkActiveClass: 'is-active',
  // mode: 'history',
  routes
})

Sentry.init({
  Vue,
  dsn: 'https://6e541d48073e4b228d60cd6e2cef7361@o4504162316451840.ingest.sentry.io/4504195559129088',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ['localhost', 'https://ifanflex.staging.jobizo.com', /^\//],
      logsErrors: true
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  logsErrors: true,
  tracesSampleRate: 1.0
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access-token')
  const auth = to.matched.some((record) => record.meta.auth)
  console.log(to, from, token, auth)
  if (auth && !token) { return next({ path: '/sign_in', query: { redirect: to.fullPath } }) }
  next()
})

// router.beforeEach(initCurrentUserStateMiddleware);
// router.beforeEach(checkAccessMiddleware);
// router.beforeEach(setPageTitleMiddleware);

export default router
